import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Host,
  Injector,
  Input,
  Optional,
  TemplateRef,
  Type,
} from '@angular/core';
import { GameDynamicBlockContainerDirective } from './game-dynamic-block-container.directive';

@Directive({
    selector: '[msOrchestratorBlock]',
    standalone: false
})
export class GameDynamicBlockDirective {
  @Input('msOrchestratorBlock') public name: string;

  private func: (component: any) => void;

  private componentType: Type<any>;

  constructor(
    public readonly elementRef: ElementRef,
    public readonly cdr: ChangeDetectorRef,
    @Optional() public readonly templateRef: TemplateRef<any>,
    public readonly injector: Injector,
    public readonly container: GameDynamicBlockContainerDirective<any>,
  ) {}

  ngOnInit() {
    this.container.addBlock(this);
  }

  ngAfterViewInit() {
    if (this.componentType) {
      const component = this.injector.get(this.componentType, null, { optional: true });
      if (component) {
        this.func(component);
      } else {
        throw new Error(`Убедитесь, что для ${this.elementRef.nativeElement} определен ${this.componentType.name}.`);
      }
    }
  }

  ngOnDestroy() {
    this.container.removeBlock(this);
  }

  provideForComponent(func: any, componentType: Type<any>) {
    this.func = func;
    this.componentType = componentType;
    const component = this.injector.get(componentType, null, { optional: true });
    if (component) {
      this.func(component);
    }
  }
}
